import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/tether-usdt-logo.png")